import { theme } from '@garnish/constants';

export const NAVBAR_CONTENT_HEIGHT = 56;
export const NAVBAR_BASE_CONTAINER_HEIGHT = NAVBAR_CONTENT_HEIGHT + theme.spacing['6'];
